<template>
    <div class="topbar-container">
        <zbList
            v-model="store"
            class="v-list"
            :isKeep="true"
            itemCls="r6 list-item"
            v-slot:default="{ item }"
            emptyMessage="亲爱的车主，您还没有交易记录喔"
        >
            <div class="list-item-el r8" @click="go('UserMoneyInfo',item)">
                <div class="bh bstart">
                    <div class="fz_30 b1">{{item.withdrawStatusStr}}</div>
                    <span class="fz_32 c_333">-{{item.withdrawPoint}}</span>
                    <div class="ico-next bg-contain"></div>
                </div>
                <div class="fz_26 c_8B8 text">{{item.withdrawTime}}</div>
            </div>
        </zbList>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { list } from "@/mixin/list";
import { routeCache } from "@/mixin/cache";
import zbList from "@/components/data/List";
import { moneyhistory } from "@/api/money";
export default {
    mixins: [user, list, routeCache],
    name: "UserMoneyHome",
    components: { zbList },
    data() {
        return {
            store: {
                proxy: {
                    getList: moneyhistory
                }
            }
        };
    },
    methods: {
        userLoginend() {
            if (this.getCache().isVerification) {
                this.storeLoad();
            }
        }
    }
};
</script>

<style scoped lang="scss">
.topbar-container {
    background-color: #f1f2f3;
}
.ico-blackadd {
    width: 36px;
    height: 36px;
}
/deep/.list-item {
    padding: 24px 30px 0 30px;
    .list-item-el {
        background-color: #fff;
        padding: 30px;
        .ico-next {
            width: 16px;
            height: 30px;
            margin-left: 19px;
        }
        .text {
            padding-top: 23px;
        }
    }
}
</style>